/**
 * Fix accessibility issues in the Google Reviews widget (app-rendered).
 * - Decorative SVGs: mark as hidden from assistive tech.
 * - Weak image names (e.g. alt="Thumbnail"): provide a meaningful alt.
 */
(function() {
  'use strict';

  function hasAccessibleName(svg) {
    return (
      svg.getAttribute('aria-label') ||
      svg.getAttribute('aria-labelledby') ||
      svg.querySelector('title') ||
      svg.getAttribute('role') === 'img'
    );
  }

  function fixSvg(svg) {
    if (hasAccessibleName(svg)) return;
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
  }

  function fixReviewThumbnail(img) {
    var src = (img.getAttribute('src') || '').toLowerCase();
    // Limit changes to the Google Reviews logo image.
    if (src.indexOf('google-review-assets') === -1 || src.indexOf('/logo/') === -1) return;
    // The same content is already announced by adjacent text/link; treat logo as decorative.
    img.setAttribute('alt', '');
    img.setAttribute('aria-hidden', 'true');
    img.setAttribute('role', 'presentation');
  }

  function runFix() {
    var root = document.body;
    if (!root) return;

    // 1) Decorative star icons (grp-full-star, grp-empty-star)
    root.querySelectorAll('.grp-full-star, .grp-empty-star').forEach(fixSvg);

    // 2) Close button icon - parent control should provide the label
    root.querySelectorAll('.grp-offcanvas-close svg').forEach(fixSvg);

    // 3) Any other SVG inside a Google Reviews widget container (class contains "grp-")
    //    that still has no accessible name - e.g. Google logo SVG
    root.querySelectorAll('[class*="grp-"]').forEach(function(container) {
      container.querySelectorAll('svg').forEach(fixSvg);
    });

    // 4) Google Reviews thumbnail image with weak name (e.g. "Thumbnail")
    root.querySelectorAll('img').forEach(fixReviewThumbnail);
  }

  function init() {
    runFix();
    // Widget content (e.g. offcanvas with more stars) may be injected later
    var observer = new MutationObserver(function(mutations) {
      runFix();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    // Re-run once after a short delay for async app content
    setTimeout(runFix, 500);
    setTimeout(runFix, 2000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
